<template>
  <v-chip v-if="employee" class="pl-0">
    <v-avatar style="width: 32px !important; height: 32px !important" class="mr-1" :color="imageUrl ? 'white' : 'red'">
      <span v-if="!imageUrl" class="white--text font-weight-bold">
        {{ employee.firstName.substring(0, 1).toUpperCase() }}{{ employee.lastName.substring(0, 1).toUpperCase() }}
      </span>
      <v-img v-else :src="imageUrl" />
    </v-avatar>
    {{ employee.firstName }} {{ employee.lastName }}
  </v-chip>
</template>

<script>
  export default {
    name: "EmployeeChip",
    props: ["employee"],
    computed: {
      imageUrl() {
        return this.$helpers.get(this.employee, "profile.imageUrl");
      }
    }
  };
</script>
